import { useMemo } from 'react'
import { UGELayer } from '../../../../types'

type Props = {
    className?: string
    duration: number
    layer: UGELayer
}

const UGELayersEditorLayerHeaderTime = ({ className, duration, layer }: Props) => {
    const timing = useMemo(() => layer.props.timing || { start: 0, end: 1 }, [layer.props])
    const timingLabel = useMemo(() => {
        if (!duration) {
            return 0
        }

        return Math.round((timing.end - timing.start) * duration * 100) / 100
    }, [duration, timing])

    return (
        <span className={className}>
            {timingLabel}s <span>/ {duration}s</span>
        </span>
    )
}

export default UGELayersEditorLayerHeaderTime
